import { mockInsightMetricsQueryOperationQuery } from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockInsightMetricsQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          meanTimeToDetection: 2,
          meanTimeToRemediation: 2,
          meanTimeToResponse: 2,
        },
      });
    }
  ),
];
